import type { FooterData } from '@/data/types';
import footerData from '@/data/footer.json';

export function useFooterData() {
  return { footerData: footerData as FooterData };
}